import styled from "styled-components";

export const PageContainerComponent = styled.main`
  width: calc(100vw);
  min-height: 100vh;
  padding-top: 260px;
  padding-bottom: 80px;

  @media(max-width: 1440px) {
    padding-top: 250px;
  }

  @media(max-width: 1264px) {
    padding-top: 250px;
  }

  @media(max-width: 1024px) {
    padding-top: 197px;
  }

  @media(max-width: 768px){
    padding-top: 40px;
  }

  @media(max-width: 431px) {
    padding-top: 231px;
  }
`;
